import { Injectable } from '@angular/core';
import { ApiUrlConstant } from '@app-constants/api-url.constant';
import { environment } from '@app-environments/environment';
import { RestApiService } from '@app-services/rest/rest-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService extends RestApiService{
  apiUrl = ApiUrlConstant.examUrl;
  newApi=ApiUrlConstant.newApiUrl;
  omsapiUrl = ApiUrlConstant.omsdevapi;
  getStudentExamSchedule(body:any): Observable<any>{
    const url = this.newApi + `registrations/getstudentscheduledexam`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    return this.getByHeaders<any>(url,body,headers);
  }
  registerExamSchedule(body:any): Observable<any>{
    const url = this.newApi + `registrations/registerstudentscheduledexam`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    // if(body?.studentid && environment.branch =='staging'){
    //     body.studentid = localStorage.getItem('user_details_from_server')? JSON.parse(localStorage.getItem('user_details_from_server'))?.userId:body.studentid
    // }
    return this.getByHeaders<any>(url,body,headers);
  }
  getSCORERegistrations(body) {
    let url = this.newApi + 'registrations/getregisteredexams?phone='+localStorage.getItem('studentid');
    if(body?.action == 'participation'){
      url = url+'&downloadcertificate=true'
    }
    let headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    return this.getWithHeaders<any>(url, headers);
  }
  getSlots(params){
    let url = this.apiUrl+'rules/timeslots';
    let headers = {
      'accesstoken': localStorage.getItem('token')
    };
    return this.post<any>(url, params, headers)
  }
  getScorePackages(params){
    let url = this.omsapiUrl+'packages/subscriptionsByYear';
    let headers = {
      'accesstoken': localStorage.getItem('token')
    };
    return this.getWithHeadersAndParams<any>(url,  headers,params)
  }
  mySubscription(params){
    let url = this.omsapiUrl+'userorders/mySubscription';
    let headers = {
      'accesstoken': localStorage.getItem('token')
    };
    return this.getWithHeadersAndParams<any>(url,  headers,params).toPromise()
  }
  changeUserOrderSubscription(body){
    let url = this.omsapiUrl+'userorders/changeUserOrderSubscription';
    let headers = {
      'accesstoken': localStorage.getItem('token')
    };
    return this.put<any>(url,  body,headers)
  }
  getStudentHalltickets() {
    let studentid = localStorage.getItem('studentid');
    let body = {
      "studentid": studentid
    }
    let url = this.newApi + 'registrations/getstudenthalltickets';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    return this.getByHeaders<any>(url, body, headers);
  }
  getStudentScheduledExamsData() {
    let studentid = localStorage.getItem('studentid');
    let body = {
      "studentid": studentid
    }
    let url = this.newApi + 'registrations/getStudentScheduledExamsData';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    return this.getByHeaders<any>(url, body, headers);
  }
  getStudentScheduledScoreExamsData() {
    let studentid = localStorage.getItem('studentid');
    let body = {
      "studentid": studentid
    }
    let url = this.newApi + 'score/getStudentScheduledExamsData';
    let headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    return this.getByHeaders<any>(url, body, headers);
  }
  getScoreTimeSlots(params){
    console.log(params);
    let url = this.apiUrl+'score/getScoreTimeslots';
    let headers = {
      'accesstoken': localStorage.getItem('token')
    };
    return this.post<any>(url, params, headers)
  }
  studentRescheduleExam(body:any): Observable<any>{
    const url = this.apiUrl + `score/studentRescheduleExam`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
    };
    return this.getByHeaders<any>(url,body,headers);
  }
  getAllCartItems(param){
    return this.getWithHeadersAndParams<any>(this.omsapiUrl+'cart/getAllCartItemByUserId',{},param)
  }
  saveCart(body){
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'Content-Type': 'application/json',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN'
    };
    return this.post<any>(this.omsapiUrl+'cart/save', body, headers)
  }
  
  
}
